import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const { user, empresas } = useSelector((state) => state.auth); // o auth, según tu store
  const location = useLocation();

  if (!user) return <Navigate to="/login" replace />;

  const tieneEmpresas = empresas && empresas.length > 0;
  const enCrearEmpresa = location.pathname === "/company";

  if (!tieneEmpresas && !enCrearEmpresa) {
    return <Navigate to="/company" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
